/* DEMARE Konfigurator — datengetrieben (Varianten/Kordeln aus Liquid-JSON).
   Ablauf seit 17.09. (Julian): erst Smartphone, dann Huelle, dann Paket, dann Kordeln.
   Vanilla JS, keine Libraries. Teilt demare:lastModel mit PDP/PLP. */
(function () {
  'use strict';
  var root = document.querySelector('[data-kf]');
  if (!root) return;
  var LS = 'demare:lastModel';

  var cfg = {
    casePrice: parseInt(root.dataset.casePrice || '2990', 10),
    cordPrice: parseInt(root.dataset.cordPrice || '1590', 10),
    freeShip: parseInt(root.dataset.freeShip || '5000', 10),
    /* Set-Rabatt je Kordel-Platz in Cent (Festbetrag, snippets/dm-set-off) und
       Nachfuell-Pack-Rabatt in Cent auf 4 Kordeln (snippets/dm-pack-off) — wie die Kasse */
    off: parseInt(root.dataset.setOff || '0', 10) || 0,
    packOff: parseInt(root.dataset.packOff || '0', 10) || 0
  };

  /* Huelle -> [[Varianten-ID, Modellname, verfuegbar], ...] */
  var VAR = {};
  try { VAR = JSON.parse(root.querySelector('[data-kf-data]').textContent); } catch (e) {}
  /* Huellenfarbe (downcase, ohne Leerzeichen) -> [Adapter-Varianten-ID, Preis] */
  var ADAPT = {};
  try { ADAPT = JSON.parse(root.querySelector('[data-kf-adapters]').textContent); } catch (e) {}

  function $(s) { return root.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  /* "iPhone 14 ProMax" und "iPhone 14 Pro Max" sind dasselbe Modell */
  function norm(t) { return String(t || '').toLowerCase().replace(/\s+/g, ''); }
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  var el = {
    step: { model: $('[data-kf-step="model"]'), 'case': $('[data-kf-step="case"]'),
            pkg: $('[data-kf-step="pkg"]'), cords: $('[data-kf-step="cords"]') },
    cases: $$('[data-kf-case]'), pkgs: $$('[data-kf-pkg]'), cords: $$('[data-kf-cord]'),
    slots: $('[data-kf-slots]'), empty: $('[data-kf-empty]'),
    mCur: $('[data-kf-model-current]'), mCnt: $('[data-kf-model-count]'),
    mTog: $('[data-kf-model-toggle]'), mPan: $('[data-kf-model-panel]'),
    mSearch: $('[data-kf-model-search]'), mBrands: $('[data-kf-brands]'), mList: $('[data-kf-model-list]'),
    skip: $('[data-kf-skip]'), premiumHead: $('[data-kf-premium-head]'),
    sum: $('[data-kf-sum]'), sumStage: $('[data-kf-sum-stage]'), sumList: $('[data-kf-sum-list]'),
    sumPrice: $('[data-kf-sum-price]'), sumWas: $('[data-kf-sum-was]'), sumSave: $('[data-kf-sum-save]'),
    sumNeed: $('[data-kf-sum-need]'), add2: $('[data-kf-add2]'),
    bar: document.querySelector('[data-kf-bar]'),
    barImgs: document.querySelector('[data-kf-bar-imgs]'),
    barT: document.querySelector('[data-kf-bar-title]'),
    barP: document.querySelector('[data-kf-bar-price]'),
    barWas: document.querySelector('[data-kf-bar-was]'),
    barShip: document.querySelector('[data-kf-bar-ship]'),
    fill: document.querySelector('[data-kf-bar-fill]'),
    add: document.querySelector('[data-kf-add]')
  };

  var S = { model: null, modelKey: null, onlyCords: false, caseBtn: null, variant: null,
            pkg: null, slots: [], target: 0, pendingCase: null };

  function lock(k, on) { if (el.step[k]) el.step[k].classList.toggle('is-locked', !!on); }
  function done(k, on) { if (el.step[k]) el.step[k].classList.toggle('is-done', !!on); }
  /* 15.10.: waehrend der Vorauswahl aus der Adresse (?model=&case=&cords=) nicht scrollen */
  var quiet = false;
  function goTo(k) { if (quiet) return; if (el.step[k]) el.step[k].scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* ---------- Modelle aus allen Huellen sammeln ---------- */
  var MODELS = [];          /* [{key, title, brand}] in Shop-Reihenfolge */
  (function collect() {
    var seen = {}, spell = {};
    Object.keys(VAR).forEach(function (h) {
      VAR[h].forEach(function (v) {
        var k = norm(v[1]);
        spell[k] = spell[k] || {};
        spell[k][v[1]] = (spell[k][v[1]] || 0) + 1;
        if (!seen[k]) { seen[k] = true; MODELS.push({ key: k }); }
      });
    });
    MODELS.forEach(function (m) {
      var best = null, n = -1;
      Object.keys(spell[m.key]).forEach(function (t) { if (spell[m.key][t] > n) { n = spell[m.key][t]; best = t; } });
      m.title = best;
      m.brand = brandOf(best);
    });
  })();

  function brandOf(t) {
    var s = t.toLowerCase();
    if (s.indexOf('iphone') === 0) return 'iPhone';
    if (s.indexOf('samsung') === 0) return 'Samsung';
    if (s.indexOf('google') === 0 || s.indexOf('pixel') >= 0) return 'Google';
    return 'Weitere';
  }

  /* Welche Huellen gibt es fuer dieses Modell? */
  function variantFor(handle, key) {
    var vs = VAR[handle] || [];
    for (var i = 0; i < vs.length; i++) if (norm(vs[i][1]) === key && vs[i][2]) return vs[i][0];
    return null;
  }

  /* Echter Preis der gewaehlten Huellen-Variante.
     Ohne den rechnete der Streichpreis pauschal mit casePrice (29,90) — bei
     Himmelblau/Flieder (14-18 EUR) und Neon (26,90) war das ein erfundener
     Referenzpreis. Faellt der Preis weg, gilt wieder die Pauschale. */
  function priceFor(handle, key) {
    var vs = VAR[handle] || [];
    for (var i = 0; i < vs.length; i++) {
      if (norm(vs[i][1]) === key && vs[i][2]) {
        return (typeof vs[i][3] === 'number' && vs[i][3] > 0) ? vs[i][3] : null;
      }
    }
    return null;
  }

  /* Was die Huelle einzeln kostet — echter Preis, sonst Pauschale. */
  function casePriceNow() {
    if (!S.caseBtn || !S.modelKey) return cfg.casePrice;
    var p = priceFor(S.caseBtn.dataset.handle, S.modelKey);
    return p === null ? cfg.casePrice : p;
  }
  function casesFor(key) {
    return el.cases.filter(function (c) { return !!variantFor(c.dataset.handle, key); }).length;
  }

  /* ---------- Schritt 1: Modell ---------- */
  function buildModels() {
    var brands = [];
    MODELS.forEach(function (m) { if (brands.indexOf(m.brand) < 0) brands.push(m.brand); });
    el.mBrands.innerHTML = brands.map(function (b) {
      return '<button type="button" class="kf-model__brand" aria-pressed="false" data-brand="' + b + '">' + b + '</button>';
    }).join('');
    el.mList.innerHTML = MODELS.map(function (m) {
      var n = casesFor(m.key);
      return '<button type="button" class="kf-model__opt" aria-current="false" data-key="' + m.key +
        '" data-title="' + m.title.replace(/"/g, '&quot;') + '" data-brand="' + m.brand + '"' +
        (n ? '' : ' disabled') + '>' + m.title +
        '<small>' + (n ? n + (n === 1 ? ' Hülle' : ' Hüllen') : 'derzeit nicht lieferbar') + '</small></button>';
    }).join('');
    el.mList.querySelectorAll('.kf-model__opt').forEach(function (o) {
      o.addEventListener('click', function () { if (!o.disabled) setModel(o.dataset.key, true); });
    });
    el.mBrands.querySelectorAll('.kf-model__brand').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') === 'true';
        el.mBrands.querySelectorAll('.kf-model__brand').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', String(!on));
        filterModels();
      });
    });
    el.mCnt.textContent = MODELS.length + ' Modelle — tippe deins an';
  }

  function filterModels() {
    var q = norm(el.mSearch ? el.mSearch.value : '');
    var brand = null;
    el.mBrands.querySelectorAll('.kf-model__brand').forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') brand = b.dataset.brand;
    });
    el.mList.querySelectorAll('.kf-model__opt').forEach(function (o) {
      o.hidden = !((!q || o.dataset.key.indexOf(q) >= 0) && (!brand || o.dataset.brand === brand));
    });
  }

  function setModel(key, scroll) {
    var m = null;
    MODELS.forEach(function (x) { if (x.key === key) m = x; });
    if (!m) return;
    S.model = m.title; S.modelKey = key; S.onlyCords = false;
    el.mCur.textContent = m.title;
    var n = casesFor(key);
    el.mCnt.textContent = n + (n === 1 ? ' Hülle passt' : ' Hüllen passen');
    el.mList.querySelectorAll('.kf-model__opt').forEach(function (o) {
      o.setAttribute('aria-current', String(o.dataset.key === key));
    });
    try { localStorage.setItem(LS, m.title); } catch (e) {}
    el.mPan.hidden = true;
    if (el.mTog) el.mTog.textContent = 'ändern';
    done('model', true); lock('case', false);
    applyCaseAvailability();
    /* gewaehlte Huelle behalten, wenn es sie fuer das neue Modell gibt */
    if (S.caseBtn && !S.caseBtn.disabled) {
      S.variant = variantFor(S.caseBtn.dataset.handle, key);
      refreshPackages();
    } else if (S.caseBtn) {
      resetCase();
    }
    /* Huellenwunsch vom PDP-Teaser (?case=) jetzt einloesen */
    if (S.pendingCase && !S.caseBtn) {
      var pk = S.pendingCase;
      var hitc = el.cases.filter(function (c) { return !c.disabled && (c.dataset.akey === pk || norm(c.dataset.color) === pk); })[0];
      if (hitc) {
        S.pendingCase = null; pickCase(hitc);
        if (S.pendingCords) { var pc = S.pendingCords; S.pendingCords = null; applyCords(pc); render(); }
        return;
      }
    }
    render();
    if (scroll) goTo('case');
  }

  function onlyCords() {
    S.model = null; S.modelKey = null; S.onlyCords = true; S.variant = null;
    el.mCur.textContent = 'Nur Kordeln — ohne Hülle';
    el.mCnt.textContent = 'Wähle die Farbe deiner Hülle, damit der Adapter passt';
    el.mPan.hidden = true;
    if (el.mTog) el.mTog.textContent = 'doch mit Hülle';
    done('model', true); lock('case', false);
    applyCaseAvailability();
    if (S.caseBtn) refreshPackages();
    render();
    goTo('case');
  }

  /* ---------- Schritt 2: Huelle ---------- */
  function applyCaseAvailability() {
    el.cases.forEach(function (c) {
      var ok = S.onlyCords || !!variantFor(c.dataset.handle, S.modelKey);
      c.disabled = !ok;
      c.classList.toggle('is-na', !ok);
    });
  }

  function resetCase() {
    S.caseBtn = null; S.variant = null; S.pkg = null; S.slots = []; S.target = 0;
    el.cases.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    el.slots.innerHTML = '';
    done('case', false); done('pkg', false); done('cords', false);
    lock('pkg', true); lock('cords', true);
    el.step.model && el.step.model.classList.remove('is-skipped');
    filterCords();
  }

  function adapterFor() {
    if (!S.caseBtn) return null;
    var key = S.caseBtn.dataset.akey || norm(S.caseBtn.dataset.color);
    return ADAPT[key] || null;
  }

  function pickCase(btn) {
    if (btn.disabled) return;
    S.caseBtn = btn;
    S.variant = S.onlyCords ? null : variantFor(btn.dataset.handle, S.modelKey);
    S.pkg = null; S.slots = []; S.target = 0;
    el.cases.forEach(function (c) { c.setAttribute('aria-pressed', String(c === btn)); });
    el.slots.innerHTML = '';
    done('case', true); lock('pkg', false); done('pkg', false);
    lock('cords', true); done('cords', false);
    refreshPackages();
    filterCords();
    render();
    goTo('pkg');
  }

  /* Wie viele Kordeln passen zur gewaehlten Huelle? Standard (Farb-Tag oder
     transparenter Adapter) plus Premium, wenn es einen Farb-Adapter gibt. */
  function availableCordCount() {
    var atag = S.caseBtn ? S.caseBtn.dataset.atag : null;
    var ad = adapterFor(), n = 0;
    el.cords.forEach(function (c) {
      if (c.disabled) return;
      if (c.dataset.premium) { if (ad) n++; return; }
      if (c.dataset.transp || (atag && (' ' + c.dataset.atags + ' ').indexOf(' ' + atag + ' ') >= 0)) n++;
    });
    return n;
  }

  function refreshPackages() {
    refreshPkgPrices();
    var n = availableCordCount();
    el.pkgs.forEach(function (p) {
      var need = parseInt(p.dataset.cords, 10);
      var nocase = p.dataset.nocase === 'true';
      var off = need > n || (S.onlyCords && !nocase);
      p.dataset.unavailable = String(off);
      if (off && p.classList.contains('is-active')) { p.classList.remove('is-active'); S.pkg = null; }
    });
    /* Nur-Kordeln-Weg: das Nachfuell-Pack ist die einzige Option -> vorwaehlen */
    if (S.onlyCords) {
      var refill = el.pkgs.filter(function (p) { return p.dataset.nocase === 'true' && p.dataset.unavailable !== 'true'; })[0];
      if (refill && !S.pkg) pickPkg(refill, false);
    }
  }

  /* ---------- Schritt 3: Paket ---------- */
  function pickPkg(p, scroll) {
    if (p.dataset.unavailable === 'true') return;
    S.pkg = { key: p.dataset.key, cords: parseInt(p.dataset.cords, 10),
              price: parseInt(p.dataset.price, 10), label: p.dataset.label,
              nocase: p.dataset.nocase === 'true' };
    el.pkgs.forEach(function (x) { x.classList.toggle('is-active', x === p); });
    var inp = p.querySelector('input'); if (inp) inp.checked = true;
    S.slots = []; S.target = 0;
    done('pkg', true);
    if (S.pkg.cords > 0) {
      lock('cords', false); done('cords', false);
      renderSlots();
      if (scroll !== false) goTo('cords');
    } else {
      lock('cords', true); el.slots.innerHTML = '';
    }
    render();
  }

  /* ---------- Schritt 4: Kordeln ---------- */
  function filterCords() {
    var atag = S.caseBtn ? S.caseBtn.dataset.atag : null;
    var ad = adapterFor(), any = false;
    el.cords.forEach(function (c) {
      var ok;
      if (c.dataset.premium) ok = !!S.caseBtn && !!ad;
      else ok = !!S.caseBtn && (!!c.dataset.transp || (atag && (' ' + c.dataset.atags + ' ').indexOf(' ' + atag + ' ') >= 0));
      c.hidden = !ok;
      if (ok) any = true;
    });
    if (el.premiumHead) el.premiumHead.hidden = !(S.caseBtn && ad);
    if (el.empty) el.empty.hidden = any || !S.caseBtn;
  }

  function renderSlots() {
    var h = '';
    for (var i = 0; i < S.pkg.cords; i++) {
      var c = S.slots[i];
      h += '<button type="button" class="kf-slot' + (c ? ' is-filled' : '') + (i === S.target ? ' is-target' : '') +
        '" data-slot="' + i + '" aria-label="Kordel-Platz ' + (i + 1) + (c ? ': ' + c.name + ' entfernen' : '') + '">' +
        (c ? '<img src="' + c.img + '" alt="">' +
             (c.sur > 0 ? '<span class="kf-slot__sur">+' + (c.sur / 100).toFixed(2).replace('.', ',').replace(',00', '') + '€</span>' : '') +
             '<span class="kf-slot__x">×</span>' : '+') + '</button>';
    }
    el.slots.innerHTML = h;
    el.slots.querySelectorAll('.kf-slot').forEach(function (s) {
      s.addEventListener('click', function () {
        var i = parseInt(s.dataset.slot, 10);
        if (S.slots[i]) S.slots[i] = null;
        S.target = i;
        renderSlots(); render();
      });
    });
  }

  function pickCord(btn) {
    if (!S.pkg || S.pkg.cords === 0 || btn.disabled) return;
    /* base = was diese Kordel einzeln WIRKLICH kostet (21.09.: vorher pauschal
       cfg.cordPrice, also 16,90 aus den Einstellungen, egal welcher Preis im
       Admin stand). */
    var real = parseInt(btn.dataset.bandPrice, 10);
    var slot = { id: btn.dataset.variant, name: btn.dataset.name, img: btn.dataset.img, sur: 0,
                 base: real > 0 ? real : cfg.cordPrice };
    if (!btn.dataset.premium && btn.dataset.surcharge) {
      slot.sur = parseInt(btn.dataset.surcharge, 10);
    }
    if (btn.dataset.premium) {
      var ad = adapterFor();
      if (!ad) return;
      var bandPrice = parseInt(btn.dataset.bandPrice, 10);
      slot.sur = Math.max(0, bandPrice + ad[1] - cfg.cordPrice);
      slot.base = bandPrice + ad[1];
      slot.bandPrice = bandPrice;
      slot.adapterPrice = ad[1];
      slot.adapterId = ad[0];
    }
    S.slots[S.target] = slot;
    slot.sur = Math.max(0, itemCheckout(slot) - refCheckout());
    var next = -1;
    for (var i = 0; i < S.pkg.cords; i++) if (!S.slots[i] && next < 0) next = i;
    if (next >= 0) S.target = next;
    if (next < 0) done('cords', true);
    renderSlots(); render();
  }

  /* ---------- Summen ---------- */
  function filled() { return S.slots.filter(Boolean).length; }

  /* ---------- Kasse nachrechnen (23.09.) ----------
     Set-Rabatt (BXGY, Festbetrag): sobald eine Smart-Case-Huelle im Warenkorb liegt,
     werden 2 Teile aus Kordeln + Baendern/Gurten um je cfg.off Cent billiger
     ("8,40 € Rabatt je Stueck"). Adapter bleiben voll. Shopify braucht dafuer ZWEI
     rabattfaehige Teile — Huelle + 1 Kordel bekommt nichts (gemessen 22.09.); im
     Konfigurator sind beide Plaetze immer belegt, also gilt der Rabatt.
     Nachfuell-Pack (ohne Huelle): 4 Standardkordeln, cfg.packOff Cent auf die Summe. */
  function discounted(cents) { return Math.max(0, cents - cfg.off); }
  function setDiscountActive() {
    return !!(S.pkg && !S.pkg.nocase && S.pkg.cords >= 2);
  }
  function itemCheckout(slot) {
    if (!slot) return 0;
    if (!setDiscountActive()) return slot.base;
    if (slot.adapterId) return discounted(slot.bandPrice) + slot.adapterPrice;   /* Band rabattiert, Adapter voll */
    return discounted(slot.base);
  }
  function refCheckout() {
    var r = refCordPrice();
    return setDiscountActive() ? discounted(r) : r;
  }
  /* Aufpreise haengen davon ab, ob der Rabatt gerade greift -> bei jedem Render neu */
  function recalcSur() {
    S.slots.forEach(function (c) { if (c) c.sur = Math.max(0, itemCheckout(c) - refCheckout()); });
  }
  function packActive() {
    if (!S.pkg || !S.pkg.nocase || S.pkg.cords < 4) return false;
    /* Der Pack-Rabatt zaehlt nur Standardkordeln; ein Premium-Band im Pack bricht ihn */
    return S.slots.filter(function (c) { return c && c.adapterId; }).length === 0;
  }
  function setTotal() {
    if (!S.pkg) return 0;
    var caseP = S.pkg.nocase ? 0 : casePriceNow();
    if (S.pkg.cords === 0) return caseP;
    var sum = caseP;
    for (var i = 0; i < S.pkg.cords; i++) {
      sum += S.slots[i] ? itemCheckout(S.slots[i]) : refCheckout();
    }
    if (packActive()) sum = Math.max(0, sum - cfg.packOff);
    return sum;
  }
  /* Paketpreise im Schritt 3 an die gewaehlte Huelle anpassen */
  function refreshPkgPrices() {
    el.pkgs.forEach(function (p) {
      var span = p.querySelector('[data-kf-pkg-price]');
      if (!span || !S.caseBtn) return;
      var cords = parseInt(p.dataset.cords, 10);
      var caseP = casePriceNow();
      var r = refCordPrice();
      var v;
      if (p.dataset.nocase === 'true') v = Math.max(0, cords * r - cfg.packOff);
      else v = cords === 0 ? caseP : caseP + cords * discounted(r);
      span.textContent = (cords > 0 && cordsVary() ? 'ab ' : '') + (v / 100).toFixed(2).replace('.', ',') + ' €';
    });
  }

  /* Referenz fuer noch leere Plaetze: die guenstigste Kordel, die zur gewaehlten
     Huelle gerade waehlbar ist. Konservativ — der Streichpreis kann damit nie
     ueber einem echten Einzelkauf liegen. */
  /* Kosten die gerade waehlbaren Standard-Kordeln unterschiedlich viel? Dann "ab". */
  function cordsVary() {
    var seen = null, vary = false;
    el.cords.forEach(function (c) {
      if (c.hidden || c.disabled || c.dataset.premium) return;
      var p = parseInt(c.dataset.bandPrice, 10);
      if (seen === null) seen = p; else if (p !== seen) vary = true;
    });
    return vary;
  }

  function refCordPrice() {
    var best = 0;
    el.cords.forEach(function (c) {
      if (c.hidden || c.disabled || c.dataset.premium) return;
      var p = parseInt(c.dataset.bandPrice, 10);
      if (p > 0 && (best === 0 || p < best)) best = p;
    });
    return best || cfg.cordPrice;
  }
  function surTotal() { return S.slots.filter(Boolean).reduce(function (a, c) { return a + (c.sur || 0); }, 0); }
  function missing() {
    if (!S.onlyCords && !S.model) return 'Wähle dein Smartphone';
    if (!S.caseBtn) return 'Wähle deine Hülle';
    if (!S.pkg) return 'Wähle dein Paket';
    if (!S.pkg.nocase && !S.variant) return 'Diese Hülle gibt es nicht für dein Modell';
    var rest = S.pkg.cords - filled();
    if (rest > 0) return 'Noch ' + rest + (rest === 1 ? ' Kordel' : ' Kordeln') + ' wählen';
    return '';
  }
  function ready() { return missing() === ''; }

  function render() {
    refreshPkgPrices();
    recalcSur();
    var need = missing(), ok = need === '';
    var total = setTotal();
    var was = 0;
    if (S.pkg) {
      was = (S.pkg.nocase ? 0 : casePriceNow()) +
        S.slots.filter(Boolean).reduce(function (a, c) { return a + (c.base || cfg.cordPrice); }, 0) +
        (S.pkg.cords - filled()) * refCordPrice();
    }

    /* Vorschau */
    if (el.sum) {
      el.sum.hidden = !S.caseBtn;
      if (S.caseBtn) {
        var stage = '';
        if (!(S.pkg && S.pkg.nocase)) stage += '<img class="kf-sum__case" src="' + S.caseBtn.dataset.img + '" alt="Smart Case ' + S.caseBtn.dataset.color + '">';
        var cordsIn = S.slots.filter(Boolean);
        stage += '<span class="kf-sum__cords">';
        cordsIn.forEach(function (c) { stage += '<img src="' + c.img + '" alt="' + c.name + '">'; });
        if (S.pkg) for (var i = cordsIn.length; i < S.pkg.cords; i++) stage += '<span class="kf-sum__ph">+</span>';
        stage += '</span>';
        el.sumStage.innerHTML = stage;

        var li = '';
        if (!(S.pkg && S.pkg.nocase)) li += '<li><b>Smart Case ' + S.caseBtn.dataset.color + '</b>' + (S.model ? ' · ' + S.model : '') + '</li>';
        else li += '<li><b>Ohne Hülle</b> · Adapter passend zu ' + S.caseBtn.dataset.color + '</li>';
        cordsIn.forEach(function (c) {
          li += '<li>' + c.name + (c.sur > 0 ? ' <span class="kf-sum__sur">+' + eur(c.sur) + '</span>' : '') +
                (c.adapterId ? ' <span class="kf-sum__note">inkl. Adapter</span>' : '') + '</li>';
        });
        el.sumList.innerHTML = li;
        var abSum = S.pkg && S.pkg.cords > filled() && cordsVary();
        el.sumPrice.textContent = S.pkg ? (abSum ? 'ab ' : '') + eur(total) : '—';
        el.sumWas.hidden = !(S.pkg && was > total);
        el.sumWas.textContent = eur(was);
        el.sumSave.textContent = S.pkg && was > total ? 'Du sparst ' + eur(was - total) + ' gegenüber dem Einzelkauf' : '';
        el.sumNeed.textContent = need;
        el.add2.disabled = !ok;
      }
    }

    /* Sticky-Leiste */
    if (!el.bar) return;
    el.bar.hidden = !S.caseBtn;
    if (!S.caseBtn) return;
    var imgs = S.pkg && S.pkg.nocase ? '' : '<img src="' + S.caseBtn.dataset.img + '" alt="">';
    S.slots.filter(Boolean).forEach(function (c) { imgs += '<img src="' + c.img + '" alt="">'; });
    el.barImgs.innerHTML = imgs;
    var t = S.pkg && S.pkg.nocase ? 'Kordeln für ' + S.caseBtn.dataset.color : 'Smart Case ' + S.caseBtn.dataset.color;
    if (S.model && !(S.pkg && S.pkg.nocase)) t += ' · ' + S.model;
    if (S.pkg) t += ' · ' + S.pkg.label + (S.pkg.cords ? ' (' + filled() + '/' + S.pkg.cords + ')' : '');
    el.barT.textContent = t;
    if (S.pkg) {
      el.barP.textContent = eur(total);
      el.barWas.hidden = was <= total;
      el.barWas.textContent = eur(was);
      var diff = cfg.freeShip - total;
      var shipTxt = diff <= 0 ? 'Gratisversand inklusive' : 'Noch ' + eur(diff) + ' bis zum Gratisversand';
      el.barShip.textContent = was > total ? 'Du sparst ' + eur(was - total) + ' · ' + shipTxt : shipTxt;
      if (el.fill) el.fill.style.width = Math.min(100, total / cfg.freeShip * 100) + '%';
    } else {
      el.barP.textContent = '—'; el.barWas.hidden = true; el.barShip.textContent = need;
      if (el.fill) el.fill.style.width = '0%';
    }
    el.add.disabled = !ok;
  }

  /* ---------- Warenkorb ---------- */
  function addToCart(btn) {
    if (!ready()) return;
    /* Zuletzt geschickte Position rendert oben -> Huelle ans Ende (= Set-Kopf) */
    var items = [];
    var sid = 'set-' + Date.now().toString(36);
    var partProps = { 'Teil von Set': S.pkg.label, '_set_id': sid, '_set_role': 'part' };
    S.slots.filter(Boolean).forEach(function (c) {
      /* Adapter VOR dem Band: die letzte Position wird beim Nachfuell-Pack Kopfzeile */
      if (c.adapterId) {
        items.push({ id: parseInt(c.adapterId, 10), quantity: 1,
          properties: { 'Teil von Set': S.pkg.label + ' (Adapter)', '_set_id': sid, '_set_role': 'part' } });
      }
      items.push({ id: parseInt(c.id, 10), quantity: 1, properties: partProps });
    });
    if (S.pkg.nocase) {
      if (items.length) items[items.length - 1].properties = { 'Set': S.pkg.label, '_set_id': sid, '_set_role': 'case' };
    } else {
      var caseItem = { id: parseInt(S.variant, 10), quantity: 1 };
      if (S.pkg.cords > 0) caseItem.properties = { 'Set': S.pkg.label, '_set_id': sid, '_set_role': 'case' };
      items.push(caseItem);
    }
    [el.add, el.add2].forEach(function (b) { if (b) b.disabled = true; });
    if (btn) btn.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function () { window.location.href = '/cart'; })
      .catch(function () {
        [el.add, el.add2].forEach(function (b) { if (b) { b.disabled = false; b.textContent = 'Nochmal versuchen'; } });
      });
  }

  /* ---------- Verdrahtung ---------- */
  el.cases.forEach(function (c) { c.addEventListener('click', function () { pickCase(c); }); });
  el.pkgs.forEach(function (p) { p.addEventListener('click', function (e) { e.preventDefault(); pickPkg(p); }); });
  el.cords.forEach(function (c) { c.addEventListener('click', function () { pickCord(c); }); });
  if (el.mTog) el.mTog.addEventListener('click', function () {
    el.mPan.hidden = !el.mPan.hidden;
    if (!el.mPan.hidden && el.mSearch) el.mSearch.focus();
  });
  if (el.mSearch) el.mSearch.addEventListener('input', filterModels);
  if (el.skip) el.skip.addEventListener('click', onlyCords);
  if (el.add) el.add.addEventListener('click', function () { addToCart(el.add); });
  if (el.add2) el.add2.addEventListener('click', function () { addToCart(el.add2); });

  buildModels();
  applyCaseAvailability();
  filterCords();

  /* Einstieg: gemerktes Modell (PDP/PLP) oder Vorauswahl aus der Adresse.
     15.10. (Bundles): ?model=<Modellname> & ?case=<Huellenfarbe> & ?cords=<Kordel-Handle oder
     Varianten-ID>,<…>. Alles wird vorausgewaehlt, die Kundin kann jeden Schritt aendern.
     Ein Modell aus der Adresse gewinnt vor dem gemerkten Modell. */
  var params = new URLSearchParams(location.search);
  quiet = true;
  var saved = null;
  try { saved = localStorage.getItem(LS); } catch (e) {}
  var wantModel = params.get('model');
  var modelOk = function (k) { return MODELS.some(function (m) { return m.key === k && casesFor(k) > 0; }); };
  if (wantModel && modelOk(norm(wantModel))) setModel(norm(wantModel), false);
  else if (saved && modelOk(norm(saved))) setModel(norm(saved), false);
  var want = params.get('case');
  if (want) {
    S.pendingCase = norm(want).replace(/-/g, '');
    var hit = el.cases.filter(function (c) {
      return !c.disabled && (c.dataset.akey === S.pendingCase || norm(c.dataset.color) === S.pendingCase);
    })[0];
    if (S.model && hit) { S.pendingCase = null; pickCase(hit); }
    else if (!S.model && hit) {
      /* Ohne Modell: Huelle trotzdem vormerken; sie wird nach der Modellwahl eingeloest */
    }
  }
  var wantCords = (params.get('cords') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  /* Kordeln aus der Adresse in "Huelle + 2 Kordeln" einsetzen; true, wenn mind. eine passte */
  function applyCords(list) {
    var set2 = el.pkgs.filter(function (p) { return p.dataset.key === 'set2' && p.dataset.unavailable !== 'true'; })[0];
    if (!set2 || !list.length) return false;
    var was = quiet; quiet = true;
    pickPkg(set2, false);
    var ok = false;
    list.slice(0, S.pkg.cords).forEach(function (w, i) {
      var btn = el.cords.filter(function (c) {
        return !c.hidden && !c.disabled && (c.dataset.handle === w || c.dataset.variant === w);
      })[0];
      if (btn) { S.target = i; pickCord(btn); ok = true; }
    });
    quiet = was;
    return ok;
  }
  var prefilled = false;
  if (wantCords.length && S.caseBtn) prefilled = applyCords(wantCords);
  else if (wantCords.length && S.pendingCase) S.pendingCords = wantCords;
  quiet = false;
  render();
  /* Bei vollstaendiger Vorauswahl direkt bei den Kordeln landen (dort aendert man die Farben) */
  if (prefilled && el.step.cords) {
    try { el.step.cords.scrollIntoView({ block: 'start' }); window.scrollBy(0, -70); } catch (e) {}
  }
  render();
})();
